import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BackButton.css';

const BackButton = ({ to, onClick, label, state, className = '' }) => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        if (onClick) {
            onClick(e);
        } else if (to) {
            navigate(to, { state });
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            className={`premium-back-button ${className}`}
            onClick={handleBack}
            aria-label="Volver"
        >
            <svg
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 13L1 7L7 1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            {label && <span className="back-button-label">{label}</span>}
        </button>
    );
};

export default BackButton;
